import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddTool } from '../../projectDetailsActivities.models';

export const AddToolActivity = ({ values }: IProjectActivity<IProjectActivityAddTool>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_AddTool')}
      <b>{values.name}</b>.
    </span>
  );
};
